import { defineComponent, createElementBlock, openBlock, normalizeClass, Fragment, renderList, createVNode, mergeProps, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es221.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductListGrid",
  props: {
    items: {},
    size: { default: "full" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(["products-list-grid", `products-list-grid--${_ctx.size}`])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
          return openBlock(), createElementBlock("li", {
            class: "products-list-grid__item",
            key: index
          }, [
            createVNode(_sfc_main$1, mergeProps({ ref_for: true }, item), {
              footer: withCtx(() => [
                renderSlot(_ctx.$slots, "card-footer", mergeProps({ ref_for: true }, item))
              ]),
              _: 2
            }, 1040)
          ]);
        }), 128))
      ], 2);
    };
  }
});

export { _sfc_main as default };
